import React from 'react';

const Communications = ({ language }) => {
  const content = {
    English: (
      <div className="text-[15px] lg:text-[16px] text-black font-light mb-4">
        <h2 className="text-[18px] lg:text-[22px] font-semibold text-black mb-4">
          Communication
        </h2>
        <p>
          Protean forwards the application details to ITD after digitization of the form submitted.
        </p>
        <p className="mt-2">
          In case of application for allotment of PAN (Form No. 93/ Form No. 94), a new PAN is allotted by ITD. Protean prints the PAN card after allotment of PAN by ITD and dispatches the same along with an allotment letter to the respective applicant.
        </p>
        <p className="mt-2">
          In case of 'Request for New PAN Card or/and Changes or Correction in PAN data' the application request is forwarded to ITD for update of the database and after confirmation from ITD, a new PAN card is printed and dispatched to the applicant.
        </p>
        <p className="mt-2">
          All the communications are sent at the address mentioned as 'address for communication' in the form. Applicants, specifying valid e-mail ID in the application, are informed about the new PAN through e-mail in addition to the PAN allotment letter. Applicants are advised to mention their telephone number (preferably a mobile number) in the application. This ensures faster communication in case of any discrepancy in the application.
        </p>
      </div>
    ),
    Hindi: (
      <div className="text-[15px] lg:text-[16px] text-black font-light mb-4">
        <h2 className="text-[18px] lg:text-[22px] font-semibold text-black mb-4">
          संचार (Communication):
        </h2>
        <p>
          प्रोटियन द्वारा प्रस्तुत आवेदन फॉर्म के डिजिटलीकरण के पश्चात आवेदन विवरण आईटीडी को अग्रेषित किया जाता है।
        </p>
        <p className="mt-2">
          (i) पैन आवंटन के लिए आवेदन (फॉर्म संख्या ९३ / फॉर्म संख्या ९४) के मामले में, आईटीडी द्वारा नया पैन आवंटित किया जाता है। पैन आवंटन के पश्चात प्रोटियन द्वारा पैन कार्ड मुद्रित किया जाता है तथा आवंटन पत्र के साथ संबंधित आवेदक को प्रेषित किया जाता है।
        </p>
        <p className="mt-2">
          (ii) 'नए पैन कार्ड या/और पैन डेटा में परिवर्तन या सुधार के लिए अनुरोध' के मामले में, आवेदन आईटीडी को डेटाबेस अपडेट हेतु अग्रेषित किया जाता है। आईटीडी से पुष्टि प्राप्त होने के पश्चात नया पैन कार्ड मुद्रित कर आवेदक को प्रेषित किया जाता है।
        </p>
        <p className="mt-2">
          (iii) सभी संचार आवेदन पत्र में उल्लिखित 'संचार का पता' (Address for Communication) पर भेजे जाते हैं। जिन आवेदकों ने आवेदन में वैध ई-मेल आईडी प्रदान की है, उन्हें पैन आवंटन पत्र के अतिरिक्त ई-मेल के माध्यम से भी नए पैन की सूचना दी जाती है।
        </p>
        <p className="mt-2">
          (iv) आवेदकों को सलाह दी जाती है कि वे आवेदन में अपना टेलीफोन नंबर (अधिमानतः मोबाइल नंबर) अवश्य उल्लेख करें। इससे आवेदन में किसी भी त्रुटि की स्थिति में त्वरित संचार सुनिश्चित होता है।
        </p>
      </div>
    )
  };

  return <div>{content[language]}</div>;
};

export default Communications;
